import moment from 'moment'
import debounce from 'debounce'

import { DATE_FORMAT } from '@constants'

import DatePicker from './DatePicker'
import TimePicker from './TimePicker'

export const combineDateAndTime = (date, time) =>
    moment()
        .set({
            hour: time.hour(),
            minute: time.minute(),
            date: date.date(),
            month: date.month(),
            year: date.year(),
        })
        .startOf('minute')

const DateTimePicker = ({
    value,
    onChange = () => {},
    datePickerOptions = {},
    timePickerOptions = {},
    startOfWeek,
    disabled,
}) => {
    const onDateChange = date => {
        if (Boolean(date)) {
            // If value exists, combine date with existing time. Otherwise use current time.
            if (Boolean(value)) {
                onChange(combineDateAndTime(date, value))
            } else {
                onChange(combineDateAndTime(date, moment()))
            }
        }
    }

    const onTimeChange = time => {
        if (Boolean(time)) {
            // If value exists, combine time with existing date. Otherwise use current date.
            if (Boolean(value)) {
                onChange(combineDateAndTime(value, time))
            } else {
                onChange(combineDateAndTime(moment(), time))
            }
        }
    }

    return (
        <div className="date-time h-100 row no-gutters">
            <div className="col-md-6 pr-md-1 mt-md-auto">
                <DatePicker
                    value={value}
                    onChange={onDateChange}
                    displayFormat={DATE_FORMAT}
                    startOfWeek={startOfWeek}
                    disabled={disabled}
                    {...datePickerOptions}
                />
            </div>
            <div className="col-md-6 mt-2 mt-md-0">
                <TimePicker value={value} onChange={onTimeChange} {...timePickerOptions} disabled={disabled} />
            </div>
        </div>
    )
}

export default DateTimePicker
